import validate from "/usr/src/app/content/n3-promos-2dc4a2bf-646d-4e97-8b6d-e02fdaaff584/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-2dc4a2bf-646d-4e97-8b6d-e02fdaaff584/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}